import "./Tabs.css";
import { TabProps, TabType } from "./types/tabTypes";
import TabHeader from "./tabHeaders/TabHeader";
import TabContent from "./tabContent/TabContent";
import { useState } from "react";

function Tabs({ data }: TabProps) {
  const [tabContent, setTabContent] = useState<TabType>();

  return (
    <div className="tabs-wrapper row m-0 m-5">
      <TabHeader data={data} updateContent={setTabContent} />
      {tabContent && <TabContent data={tabContent} />}
    </div>
  );
}

export default Tabs;
